import React, { useState, useEffect } from "react";
import MainScreen from "../../components/MainScreen";
import { Button, Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Loading from "../../components/Loading";
import ErrorMessage from "../../components/ErrorMessage";
import { useDispatch } from "react-redux";
import { loginUser } from "../../features/userSlice";
import { Modal } from "react-bootstrap";
import "./LoginScreen.css";  // Link to external CSS file for additional styles

const LoginScreen = () => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [emp_id, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error1, setError] = useState(false);
  const [spinloading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const [menuOptions, setMenuOptions] = useState([]);

  useEffect(() => {
    if (isLoggedIn) {
      const fetchMenuOptions = async () => {
        try {
          const menuResponse = await axios.post("/api/menu/getMenuUserData", { emp_id });
          setMenuOptions(menuResponse.data);
        } catch (error) {
          console.log("Error fetching menu options:", error);
        }
      };
      fetchMenuOptions();
    }
  }, [isLoggedIn]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setError(false);
    setLoading(true);

    let userCredentials = {
      emp_id,
      password,
    };

    try {
      const result = await dispatch(loginUser(userCredentials));

      if (result.payload) {
        setIsLoggedIn(true);
        setEmail("");
        setPassword("");
        navigate("/dashboard");
      } else if (result.error) {
        setShowErrorModal(true);
        setError(true);
      }
      setLoading(false);
    } catch (error) {
      setShowErrorModal(true);
      setError(true);
      setLoading(false);
    }
  };

  return (
    <MainScreen title="Login to Your Account">
      <div className="login-container">
        {error1 && (
          <ErrorMessage variant="danger">
            Invalid User ID or Password
          </ErrorMessage>
        )}
        {spinloading && <Loading />}
        {isLoggedIn ? (
          <div className="menu-tiles-container">
            <Row>
              {menuOptions.map((menu, index) => (
                <Col key={index} md={6} className="mb-3">
                  <Button
                    variant="outline-primary"
                    className="menu-tile-btn btn-lg"
                    block
                  >
                    <Link to={menu.url} className="menu-tile-link">
                      {menu.name}
                    </Link>
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <Form onSubmit={submitHandler} className="login-form">
            <Form.Group controlId="formBasicEmail" className="mb-4">
              <Form.Label> User ID</Form.Label>
              <Form.Control
                type="text"
                value={emp_id}
                placeholder="Enter your user ID"
                onChange={(e) => setEmail(e.target.value)}
                className="login-input"
              />
            </Form.Group>
            <Form.Group controlId="formBasicPassword" className="mb-4">
              <Form.Label> Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                placeholder="Enter your password"
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
              />
            </Form.Group>
            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" className="submit-btn">
                {spinloading ? "Loading..." : "Submit"}
              </Button>
            </div>
            <div className="text-center mt-3">
              <Button
                variant="link"
                className="forgot-password-btn"
                onClick={() => navigate("/resetPassword")}
              >
                Forgot Password?
              </Button>
            </div>

          </Form>
        )}
      </div>

      {/* Error Modal */}
      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Login Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Invalid User ID or Password. Please try again.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </MainScreen>
  );
};

export default LoginScreen;
